import SettingsModule, {SettingsMenuTopCategory} from "../../../../../core/modules/settings-module";

export default class SettingsModuleSubscription extends SettingsModule {

    constructor() {
        super({
            name                     : "Plan & Subscription",
            description              : "",
            svgIcon                  : "isvg-payment",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/subscription",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.canDisable             = false
        this.hasStatus              = false
    }

}
